import React from 'react';
import { Box, Typography, Avatar, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

// Sandalyeleri masanın etrafında düzgün dairesel şekilde diz (her tip için)
const getPerimeterSeatPositions = (seatCount, width, height, scale = 1) => {
  // Sandalyeleri masanın etrafında düzgün dairesel şekilde dağıt
  const positions = [];
  const cx = width / 2;
  const cy = height / 2;
  const a = width / 2 - 24 * scale;
  const b = height / 2 - 24 * scale;
  for (let i = 0; i < seatCount; i++) {
    const angle = (2 * Math.PI * i) / seatCount - Math.PI / 2;
    const x = cx + a * Math.cos(angle) - 18 * scale;
    const y = cy + b * Math.sin(angle) - 18 * scale;
    positions.push({ left: x, top: y });
  }
  return positions;
};

const getSeatPositions = (type, seatCount, scale = 1) => {
  if (type === 'yuvarlak' || type === 'dikdortgen' || type === 'kare') {
    // Tüm masa tiplerinde sandalyeler masanın etrafında düzgün dairesel şekilde dizilsin
    let width = 200 * scale, height = 200 * scale;
    if (type === 'dikdortgen') { width = 220 * scale; height = 140 * scale; }
    if (type === 'kare') { width = 180 * scale; height = 180 * scale; }
    return getPerimeterSeatPositions(seatCount, width, height, scale);
  }
  return [];
};

const getSeatColor = (participant) => {
  if (!participant) return 'grey.200';
  if (participant.status === 'invited') return 'grey.400';
  if (participant.status === 'confirmed') return 'success.main';
  return 'error.main';
};

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length > 1) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

const TableCard = ({ table, orderNo, onSeatClick, getParticipant, selectedSeatId, scale = 1, onEdit }) => {
  let width = 200 * scale, height = 200 * scale, shapeW = 120 * scale, shapeH = 120 * scale, borderRadius = 2;
  if (table.type === 'dikdortgen') {
    width = 220 * scale; height = 140 * scale; shapeW = 180 * scale; shapeH = 80 * scale; borderRadius = 8;
  } else if (table.type === 'kare') {
    width = 180 * scale; height = 180 * scale; shapeW = 140 * scale; shapeH = 140 * scale; borderRadius = 12;
  }
  const seatCount = Math.min(table.seat_count, 15);
  const seatPositions = getSeatPositions(table.type, seatCount, scale);
  return (
    <Box sx={{ width, height, position: 'relative', mx: 'auto', my: 2 }}>
      {/* Masa şekli */}
      <Box sx={{
        position: 'absolute',
        left: (width - shapeW) / 2,
        top: (height - shapeH) / 2,
        width: shapeW,
        height: shapeH,
        borderRadius: table.type === 'yuvarlak' ? '50%' : borderRadius,
        bgcolor: 'primary.light',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
        boxShadow: 2
      }}>
        <Typography
          variant="subtitle2"
          color="primary.contrastText"
          align="center"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            maxWidth: 90 * scale,
            overflow: 'hidden',
            wordBreak: 'break-word',
            whiteSpace: 'pre-line',
            textOverflow: 'ellipsis',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}
        >
          {table.name}
          {onEdit && (
            <EditIcon fontSize="small" sx={{ cursor: 'pointer' }} onClick={e => { e.stopPropagation(); onEdit(table); }} />
          )}
        </Typography>
      </Box>
      {/* Sandalyeler */}
      {(table.seats || []).slice(0, 15).map((seat, i) => {
        const pos = seatPositions[i] || { left: width / 2, top: 10 };
        const participant = getParticipant && getParticipant(seat.participant_id);
        return (
          <Tooltip key={seat.id} title={participant ? participant.name : 'Boş'}>
            <Avatar
              sx={{
                position: 'absolute',
                left: pos.left,
                top: pos.top,
                width: 36 * scale,
                height: 36 * scale,
                bgcolor: getSeatColor(participant),
                color: seat.participant_id ? 'white' : 'grey.700',
                border: selectedSeatId === seat.id ? `${2 * scale}px solid #1976d2` : `${2 * scale}px solid transparent`,
                cursor: 'pointer',
                zIndex: 2,
                fontSize: 16 * scale,
                boxShadow: 1
              }}
              onClick={() => onSeatClick && onSeatClick(seat)}
            >
              {participant ? getInitials(participant.name) : seat.seat_number}
            </Avatar>
          </Tooltip>
        );
      })}
    </Box>
  );
};
export default TableCard; 